module.exports = __webpack_public_path__ + "static/media/wizualizacja-127.dae457a4.png";